import { render, staticRenderFns } from "./PersonaDeuda.vue?vue&type=template&id=ab2a97c2"
import script from "./PersonaDeuda.js?vue&type=script&lang=js&external"
export * from "./PersonaDeuda.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports